import { User, UserManager, SignoutResponse, UserManagerSettings } from 'oidc-client';
import { authActions } from '../../../reducers/authReducer/authSlice';
import { UserPermission } from '../../../enum/userPermissions';
import EnvWindow from '../../../utils/env';
import { AppDispatch } from '../../../store';
import axios from 'axios';
import { UserPasswordStatus } from '../../../models/user.types';

const initConfig: UserManagerSettings = {
  authority: EnvWindow.REACT_APP_AUTHORITY_URL,
  client_id: 'ckeone_react',
  redirect_uri: EnvWindow.REACT_APP_REDIRECT_URL,
  silent_redirect_uri: EnvWindow.REACT_APP_SILENT_URL,
  response_type: 'code',
  scope: 'offline_access openid profile api1 role assessmentSession',
  post_logout_redirect_uri: EnvWindow.REACT_APP_POST_LOGOUT_REDIRECT_URL,
}

let userManager = new UserManager(initConfig);

export async function loadUserFromStorage(
  dispatch: AppDispatch,
  assessmentSessionId?: string,
  setUser?: (user: User) => void,
  asExaminer?: boolean,
): Promise<void> {
  try {
    const config = {
      ...initConfig,
      scope: assessmentSessionId ? `${initConfig.scope} assessmentSession` : initConfig.scope,
      extraQueryParams: assessmentSessionId ? { assessmentSessionId, asExaminer } : undefined,
    };
    userManager = new UserManager(config);
    let user;
    if (assessmentSessionId) {
      await userManager.signinSilent({assessmentSessionId: assessmentSessionId, asExaminer: asExaminer}).then(async () => {
        user = await userManager.getUser();
        if (user && setUser) {
          setUser(user);
          dispatch(authActions.storeUserAndSetAuthHeader(user));      
        }
      });

    } else {
      user = await userManager.getUser();
    }
    if (!user) {
      dispatch(authActions.storeUserError());
    } else {
      dispatch(authActions.storeUserAndSetAuthHeader(user));
    }
  } catch (e) {
    console.error(`User not found: ${e}`);
    dispatch(authActions.storeUserError());
  }
  return;
}

export function signinRedirect(): Promise<void> {
  return userManager.signinRedirect();
}

export function signinRedirectCallback(): Promise<User> {
  return userManager.signinRedirectCallback();
}

export function signoutRedirect(): Promise<void> {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirect();
}

export function signoutRedirectCallback(): Promise<SignoutResponse> {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirectCallback();
}

export function hasPermission(user: User, permissionName: UserPermission | UserPermission[]): boolean {

  if (typeof permissionName === 'string') {
    if (user && user.profile.permission) {
      if (user.profile.permission.includes(permissionName)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    if (user && user.profile.permission) {
      const containsAll = permissionName.every((element) => {
        return user.profile.permission.indexOf(element) !== -1;
      });
      return containsAll;
    } else {
      return false;
    }
  }
}
export function userOkeId(user: User) {
  return user.profile.oke_id;
}

export const hasOnePermissionToAccess = (user: User, permission: UserPermission | UserPermission[]): boolean => {
  if (permission !== undefined) {
    if (typeof permission === 'string') {
      return hasPermission(user, permission);
    } else {
      return permission.some((p) => hasPermission(user, p));
    }
  } else return true;
};

export function silentRenewal(): Promise<User> {
  return userManager.signinSilent();
}


export function silentRenewalCallback(): Promise<void | User | undefined> {
  return userManager.signinSilentCallback().catch((e) => console.log(e));
}

export async function getPasswordStatus(): Promise<UserPasswordStatus> {
  const response = await axios.get(`${EnvWindow.REACT_APP_USERS_API_URL}/User/password/status`);
  return response.data
}

export default userManager;
